import React from 'react';

// eslint-disable-next-line max-len
const GENFLUENCER_LOGO = '/themes/theme/genfluencer/genfluencer-logo.png';
const GENFLUENCER_DARK_LOGO = '/themes/theme/genfluencer/genfluencer-dark-logo.png';

const GenfluencerTheme = {
  headerLogo: {
    src: GENFLUENCER_LOGO,
    alt: 'Genfluencer Logo',
    size: 70,
  },
  darkLogo: {
    src: GENFLUENCER_DARK_LOGO,
    alt: 'Genfluencer Logo',
    size: 70,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #CCFF33',
    height: 80,
  },
  title: 'Genfluencer',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="80"
        src={GENFLUENCER_DARK_LOGO} alt="Genfluencer Logo"
      />
      <br /><br />
      <h3>Genfluencer</h3>
    </div>
  ),
  shareSite: 'https://share.genfluencer.io',
};

export default GenfluencerTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/genfluencer.js
 **/